"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "select-initial-cards" };
const _hoisted_2 = {
    key: 0,
    class: "player_home_colony_cont"
};
const _hoisted_3 = { class: "discarded-colonies-for-aridor" };
const _hoisted_4 = { class: "megacredits" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "megacredits" };
const _hoisted_7 = {
    key: 4,
    class: "tm-warning"
};
const _hoisted_8 = { class: "label label-error" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_confirm_dialog = (0, vue_1.resolveComponent)("confirm-dialog");
    const _component_SelectCard = (0, vue_1.resolveComponent)("SelectCard");
    const _component_colony = (0, vue_1.resolveComponent)("colony");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createVNode)(_component_confirm_dialog, {
            message: "Continue without buying any project cards?",
            ref: "confirmation",
            onAccept: _ctx.confirmSelection
        }, null, 8, ["onAccept"]),
        (0, vue_1.createVNode)(_component_SelectCard, {
            playerView: _ctx.playerView,
            playerinput: _ctx.corpCardOption,
            showtitle: true,
            onsave: _ctx.noop,
            onCardschanged: _ctx.corporationChanged
        }, null, 8, ["playerView", "playerinput", "onsave", "onCardschanged"]),
        (_ctx.playerCanChooseAridor)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [...(_cache[0] || (_cache[0] = [
                        (0, vue_1.createTextVNode)("These are the colony tiles Aridor may choose from:", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_3, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerView.game.discardedColonies, (colonyName) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            class: "player_home_colony small_colony",
                            key: colonyName
                        }, [
                            (0, vue_1.createVNode)(_component_colony, {
                                colony: _ctx.getColony(colonyName),
                                active: _ctx.getColony(colonyName).isActive
                            }, null, 8, ["colony", "active"])
                        ]));
                    }), 128))
                ])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.hasPrelude)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_SelectCard, {
                key: 1,
                playerView: _ctx.playerView,
                playerinput: _ctx.preludeCardOption,
                onsave: _ctx.noop,
                showtitle: true,
                onCardschanged: _ctx.preludesChanged
            }, null, 8, ["playerView", "playerinput", "onsave", "onCardschanged"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.hasCeo)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_SelectCard, {
                key: 2,
                playerView: _ctx.playerView,
                playerinput: _ctx.ceoCardOption,
                onsave: _ctx.noop,
                showtitle: true,
                onCardschanged: _ctx.ceosChanged
            }, null, 8, ["playerView", "playerinput", "onsave", "onCardschanged"]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createVNode)(_component_SelectCard, {
            playerView: _ctx.playerView,
            playerinput: _ctx.projectCardOption,
            onsave: _ctx.noop,
            showtitle: true,
            onCardschanged: _ctx.cardsChanged
        }, null, 8, ["playerView", "playerinput", "onsave", "onCardschanged"]),
        (_ctx.selectedCorporations.length === 1)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 3 }, [
                (0, vue_1.createElementVNode)("div", null, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[1] || (_cache[1] = [
                            (0, vue_1.createTextVNode)("Starting Megacredits:", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    _cache[2] || (_cache[2] = (0, vue_1.createTextVNode)()),
                    (0, vue_1.createElementVNode)("div", _hoisted_4, (0, vue_1.toDisplayString)(_ctx.getStartingMegacredits()), 1)
                ]),
                (_ctx.hasPrelude)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [
                        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[3] || (_cache[3] = [
                                (0, vue_1.createTextVNode)("After Preludes:", -1)
                            ]))])), [
                            [_directive_i18n]
                        ]),
                        _cache[4] || (_cache[4] = (0, vue_1.createTextVNode)()),
                        (0, vue_1.createElementVNode)("div", _hoisted_6, (0, vue_1.toDisplayString)(_ctx.getStartingMegacredits() + _ctx.getAfterPreludes()), 1)
                    ]))
                    : (0, vue_1.createCommentVNode)("", true)
            ], 64))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.warning !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7, [
                (0, vue_1.createElementVNode)("label", _hoisted_8, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.warning)), 1)
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.showsave)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_AppButton, {
                key: 5,
                disabled: !_ctx.valid,
                onClick: _ctx.saveIfConfirmed,
                type: "submit",
                title: _ctx.playerinput.buttonLabel
            }, null, 8, ["disabled", "onClick", "title"]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
